import React, { useMemo } from 'react';

import { Container, Typography, Button, Grid, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: '500px',
    padding: '26px',
  },
  formTitle: {
    color: '#172B4D',
    fontWeight: 'bold',
    marginBottom: '1rem',
  },
}));

export default ({ userId, userStatus, onCloseButtonClick, onDisableUser, onEnableUser }) => {
  const classes = useStyles();

  const shouldDisabled = useMemo(() => userStatus !== 'Disabled', [userStatus]);

  const headerText = useMemo(() => {
    if (userStatus === 'Disabled') return 'enabled';
    return 'disabled';
  }, [userStatus]);

  return (
    <Container maxWidth="md" disableGutters className={classes.container}>
      <Typography className={classes.formTitle}>Change User Status Confirmation</Typography>

      <Typography variant="body1" align="left" style={{ color: '#172B4D' }}>
        Would you like to set this user to {headerText}?
      </Typography>

      <Grid container justify="flex-end" alignItems="center" style={{ marginTop: '32px' }}>
        <Button variant="outlined" color="secondary" size="medium" style={{ marginRight: '8px' }} onClick={onCloseButtonClick}>
          Cancel
        </Button>
        {shouldDisabled ? (
          <Button variant="contained" color="primary" size="medium" onClick={() => onDisableUser(userId)}>
            Yes, Disable User
          </Button>
        ) : (
          <Button variant="contained" color="primary" size="medium" onClick={() => onEnableUser(userId)}>
            Yes, Enable User
          </Button>
        )}
      </Grid>
    </Container>
  );
};
